window.initMap = window.initMap || function() {};